<template>
  <div>
    <transferenceManagebar />
    <v-container fluid>
      <base-material-card
        color="blue-grey darken-4"
        icon="mdi-monitor-dashboard"
        title="ระบบบริหารจัดการข้อมูลการย้ายสายบริหาร (Admin Overview)"
        class="mb-4"
      >
        <v-row dense class="mb-4">
          <v-col cols="12" md="4">
            <v-card
              color="info"
              dark
              elevation="3"
              class="pa-4 text-center rounded-lg"
            >
              <v-icon size="48" class="mb-2">mdi-account-group</v-icon>
              <div class="text-h6 font-weight-light">จำนวนผู้ขอย้ายทั้งหมด</div>
              <div class="text-h3 font-weight-black">
                {{ countAll }} <span class="text-h6">ราย</span>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              color="success"
              dark
              elevation="3"
              class="pa-4 text-center rounded-lg"
            >
              <v-icon size="48" class="mb-2">mdi-check-decagram</v-icon>
              <div class="text-h6 font-weight-light">ยืนยันบันทึกแล้ว</div>
              <div class="text-h3 font-weight-black">
                {{ countSaves }} <span class="text-h6">ราย</span>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              color="warning"
              dark
              elevation="3"
              class="pa-4 text-center rounded-lg"
            >
              <v-icon size="48" class="mb-2">mdi-progress-clock</v-icon>
              <div class="text-h6 font-weight-light">รอการดำเนินการ</div>
              <div class="text-h3 font-weight-black">
                {{ countTem }} <span class="text-h6">ราย</span>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense class="mb-4">
          <v-col cols="12" md="4">
            <v-card outlined class="border-left-info pa-3 rounded-lg">
              <div class="d-flex justify-space-between align-center">
                <span
                  class="subtitle-1 font-weight-bold grey--text text--darken-2"
                  >กรณีปกติ</span
                >
                <v-chip color="info" dark label>{{ countNormal }} ราย</v-chip>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card outlined class="border-left-primary pa-3 rounded-lg">
              <div class="d-flex justify-space-between align-center">
                <span
                  class="subtitle-1 font-weight-bold grey--text text--darken-2"
                  >กรณีพัฒนาคุณภาพ</span
                >
                <v-chip color="primary" dark label
                  >{{ countquality }} ราย</v-chip
                >
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card outlined class="border-left-warning pa-3 rounded-lg">
              <div class="d-flex justify-space-between align-center">
                <span
                  class="subtitle-1 font-weight-bold grey--text text--darken-2"
                  >กรณีพิเศษ</span
                >
                <v-chip color="warning" dark label>{{ countsp }} ราย</v-chip>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense class="mb-4" v-if="positionStats.length">
  <v-col cols="12">
    <div class="subtitle-1 font-weight-bold grey--text text--darken-2 mb-2">
      สถิติจำแนกตามประเภทตำแหน่ง
    </div>
  </v-col>
  <v-col
    cols="12"
    md="6"
    v-for="stat in positionStats"
    :key="stat.position_type"
  >
    <v-card outlined class="pa-3 rounded-lg">
      <div class="d-flex align-center mb-2">
        <v-icon
          :color="(positionLabels[stat.position_type] || {}).color || 'grey'"
          left
          >{{ (positionLabels[stat.position_type] || {}).icon || "mdi-account" }}</v-icon
        >
        <span class="subtitle-1 font-weight-bold">
          {{ (positionLabels[stat.position_type] || {}).label || stat.position_type }}
        </span>
        <v-spacer></v-spacer>
        <v-chip small dark :color="(positionLabels[stat.position_type] || {}).color || 'grey'">
          {{ stat.total }} ราย
        </v-chip>
      </div>
      <v-row dense class="text-center">
        <v-col cols="4">
          <div class="caption grey--text">ยืนยัน/บันทึกแล้ว</div>
          <div class="subtitle-2 success--text font-weight-bold">{{ stat.saved }}</div>
        </v-col>
        <v-col cols="4">
          <div class="caption grey--text">รอดำเนินการ</div>
          <div class="subtitle-2 warning--text font-weight-bold">{{ stat.pending }}</div>
        </v-col>
        <v-col cols="4">
          <div class="caption grey--text">กรณีพิเศษ</div>
          <div class="subtitle-2 error--text font-weight-bold">{{ stat.case_special }}</div>
        </v-col>
      </v-row>
      <v-row dense class="text-center mt-1">
        <v-col cols="6">
          <div class="caption grey--text">ปกติ</div>
          <div class="body-2 font-weight-medium">{{ stat.case_normal }}</div>
        </v-col>
        <v-col cols="6">
          <div class="caption grey--text">พัฒนาคุณภาพ</div>
          <div class="body-2 font-weight-medium">{{ stat.case_quality }}</div>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</v-row>

        <v-row dense class="mb-4">
          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold grey--text text--darken-2 mb-2">
              ตำแหน่งว่างคงเหลือทั้งระบบ (ตามกรอบอัตรากำลัง jor18)
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3 rounded-lg d-flex align-center">
              <v-icon color="primary" left large>mdi-account-tie</v-icon>
              <span class="subtitle-1 font-weight-bold">ผู้อำนวยการวิทยาลัย</span>
              <v-spacer></v-spacer>
              <v-chip color="primary" dark>{{ jor18VacantSummary.director }} ตำแหน่ง</v-chip>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3 rounded-lg d-flex align-center">
              <v-icon color="info" left large>mdi-account-tie-outline</v-icon>
              <span class="subtitle-1 font-weight-bold">รองผู้อำนวยการวิทยาลัย</span>
              <v-spacer></v-spacer>
              <v-chip color="info" dark>{{ jor18VacantSummary.se_director }} ตำแหน่ง</v-chip>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="mb-4"></v-divider>

        <v-row dense justify="center" class="pb-2">
          <v-col cols="12" md="auto" class="pa-1 text-center">
            <v-btn
              rounded
              color="blue-grey darken-3"
              dark
              :href="
                '#/admin/print_report_movement_manage_online/' +
                  periods.period_times +
                  '/' +
                  period_years
              "
              target="_blank"
            >
              <v-icon left>mdi-printer</v-icon> รายงานแบบที่ 1
            </v-btn>
          </v-col>
          <v-col cols="12" md="auto" class="pa-1 text-center">
            <v-btn
              rounded
              color="blue-grey darken-3"
              dark
              :href="
                '#/admin/print_report_movement_manage_online2/' +
                  periods.period_times +
                  '/' +
                  period_years
              "
              target="_blank"
            >
              <v-icon left>mdi-printer</v-icon> รายงานแบบที่ 2
            </v-btn>
          </v-col>
          <v-col cols="12" md="auto" class="pa-1 text-center">
            <v-btn
              rounded
              color="amber darken-3"
              dark
              :href="
                '#/admin/print_reportAssesmentManageAllDr/' +
                  periods.period_times +
                  '/' +
                  period_years +
                  '/dr'
              "
              target="_blank"
            >
              <v-icon left>mdi-printer-check</v-icon> ผล ผอ. ทั้งหมด
            </v-btn>
          </v-col>
          <v-col cols="12" md="auto" class="pa-1 text-center">
            <v-btn
              rounded
              color="amber darken-3"
              dark
              :href="
                '#/admin/print_reportAssesmentManageAllDrDev/' +
                  periods.period_times +
                  '/' +
                  period_years +
                  '/drdev'
              "
              target="_blank"
            >
              <v-icon left>mdi-printer-check</v-icon> ผล ผอ. พัฒนาฯ
            </v-btn>
          </v-col>
          <v-col cols="12" md="auto" class="pa-1 text-center">
            <v-btn
              rounded
              color="amber darken-3"
              dark
              :href="
                '#/admin/print_reportAssesmentManageAllSeDr/' +
                  periods.period_times +
                  '/' +
                  period_years +
                  '/sedr'
              "
              target="_blank"
            >
              <v-icon left>mdi-printer-check</v-icon> ผล รอง ผอ.
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>

      <base-material-card
        color="amber darken-3"
        icon="mdi-table-large"
        title="ตารางตรวจสอบและคัดเลือกตำแหน่ง"
      >
        <v-row class="px-3 pb-4 align-center">
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="เลือกคอลัมน์ที่ต้องการแสดง"
              multiple
              outlined
              dense
              return-object
              hide-details
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3" small color="primary" dark>{{
                  item.text
                }}</v-chip>
                <span v-if="index === 3" class="grey--text caption"
                  >(+{{ selectedHeaders.length - 3 }})</span
                >
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-radio-group
              v-model="position"
              @change="positionSearch()"
              row
              hide-details
              class="mt-0"
            >
              <v-radio
                label="ผู้อำนวยการ"
                value="ผู้อำนวยการวิทยาลัย"
              ></v-radio>
              <v-radio
                label="รองผู้อำนวยการ"
                value="รองผู้อำนวยการวิทยาลัย"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="ค้นหาข้อมูล..."
              single-line
              hide-details
              dense
              outlined
              color="primary"
            />
          </v-col>
          <v-col cols="12" md="3" class="text-md-right">
            <v-btn
              small
              rounded
              color="success"
              dark
              @click="exportToExcel"
            >
              <v-icon left small>mdi-file-excel</v-icon>Export Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :loading="loading"
          :headers="showHeaders"
          :items="transference_manages"
          :search="search"
          item-key="manage_id_ref"
          disable-pagination
          hide-default-footer
          class="elevation-1 mt-2"
        >
          <template v-slot:item.manage_status_save="{ item }">
            <v-chip
              @click="CancelSave(item.manage_id_tfp)"
              :color="
                item.manage_status_save === 'Confirm'
                            ? 'success'
                            : item.manage_status_save === 'Save'
                            ? 'info'
                            : 'warning'
              "
              dark
              small
            >
              <v-icon left small>{{
                item.manage_status_save === "Confirm"
                  ? "mdi-check-circle"
                  : item.manage_status_save === "Save"
                  ? "mdi-clock-outline"
                  : "mdi-alert-circle"
              }}</v-icon>
              {{ item.manage_status_save === "Confirm" ? "ยืนยัน" : item.manage_status_save === "Save" ? "บันทึก" : "ชั่วคราว" }}
            </v-chip>
          </template>

          <template v-slot:item.manage_case_move="{ item }">
            <v-chip
              :color="
                item.manage_case_move === 'normal'
                  ? 'primary'
                  : item.manage_case_move === 'quality'
                  ? 'info'
                  : 'warning'
              "
              dark
              small
            >
              {{
                item.manage_case_move === "normal"
                  ? "ปกติ"
                  : item.manage_case_move === "quality"
                  ? "คุณภาพ"
                  : "กรณีพิเศษ"
              }}
            </v-chip>
          </template>

          <!-- ตำแหน่งว่างที่ปลายทางอันดับ 1 ที่เลือกไว้ ตามกรอบอัตรากำลัง jor18 -->
          <template v-slot:item.jor18_vacant_top_choice="{ item }">
            <v-chip small :color="item.jor18_vacant_top_choice > 0 ? 'green' : 'grey'" dark>
              {{ item.jor18_vacant_top_choice }} ตำแหน่ง
            </v-chip>
          </template>
<!--  :href="'/uploads/transference/' + item.manage_file_attachment"
                  target="_blank" -->
          <template v-slot:item.attachment="{ item }">
            <v-tooltip top v-if="item.manage_file_attachment">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click="printPreview(item.manage_file_attachment)"
                 
                >
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span>ดูไฟล์แนบแบบคำร้อง</span>
            </v-tooltip>
            <v-chip v-else small color="grey" outlined>ไม่มีไฟล์</v-chip>
          </template>

          <template v-slot:item.history="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="blue-grey"
                  v-bind="attrs"
                  v-on="on"
                  @click="openLogHistory(item.manage_id_ref)"
                >
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>ดูประวัติการทำรายการ</span>
            </v-tooltip>
          </template>

          <template v-slot:item.print="{ item }">
            <v-btn
              color="info"
              icon
              :href="
                '#/user/print_info_manage/?manage_id_ref=' + item.manage_id_ref
              "
              target="_blank"
            >
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.manage_comment_supervisor="{ item }">
            <v-chip
              class="ma-1"
              v-if="item.manage_comment_supervisor"
              color="success"
              @click.stop="
                manage_comment_supervisorPosition(item.manage_id_ref)
              "
              dark
              small
            >
              {{ item.manage_comment_supervisor }}
            </v-chip>
            <v-btn
              icon
              color="info"
              v-else
              @click.stop="
                manage_comment_supervisorPosition(item.manage_id_ref)
              "
            >
              <v-icon>mdi-comment-edit-outline</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.manage_status_document="{ item }">
            <v-chip
              v-if="item.manage_status_document === 'complete'"
              color="success"
              @click.stop="comment_idPosition(item.manage_id_ref)"
              dark
              small
              >สมบูรณ์</v-chip
            >
            <v-chip
              v-else-if="item.manage_status_document === 'incomplete'"
              color="warning"
              @click.stop="comment_idPosition(item.manage_id_ref)"
              dark
              small
              >ไม่สมบูรณ์</v-chip
            >
            <v-chip
              v-else-if="item.manage_status_document === 'do_not'"
              color="error"
              @click.stop="comment_idPosition(item.manage_id_ref)"
              dark
              small
              >ไม่จัดส่ง</v-chip
            >
          </template>

          <template v-slot:item.actions="{ item }">
            <v-chip
              v-if="item.status_select === 'agree'"
              color="warning"
              dark
              small
              >ปกติ (2)</v-chip
            >
            <v-chip
              v-else-if="item.status_select === 'sw_normal'"
              color="warning"
              dark
              small
              >สับเปลี่ยน (3)</v-chip
            >
            <v-chip
              v-else-if="item.status_select === 'sw_agree'"
              color="warning"
              dark
              small
              >แลกเปลี่ยน (4)</v-chip
            >
            <v-btn
              icon
              v-else-if="item.succ_college >= 1"
              color="red"
              @click.stop="deletePosition(item.manage_id_ref)"
              ><v-icon>mdi-delete-circle</v-icon></v-btn
            >
            <v-btn
              icon
              v-else
              color="amber darken-3"
              @click.stop="select_idPosition(item.manage_id_ref)"
              ><v-icon>mdi-credit-card-plus</v-icon></v-btn
            >
          </template>

          <template v-slot:item.actionCancel="{ item }">
            <v-btn
              icon
              color="error"
              @click="CancelTransference(item.manage_id_tfp)"
              ><v-icon>mdi-cancel</v-icon></v-btn
            >
          </template>

          <template v-slot:item.action="{ item }">
            <v-btn
              icon
              color="red darken-2"
              @click="DelTransference(item.manage_id_tfp)"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
      </base-material-card>

      <v-dialog v-model="logDialog" max-width="800px">
        <v-card class="rounded-xl">
          <v-card-title class="blue-grey darken-4 white--text text-h6 py-4">
            <v-icon dark left>mdi-timeline-text-outline</v-icon>
            ประวัติการทำรายการ (System Logs)
            <v-spacer></v-spacer>
            <v-btn icon dark @click="logDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-title>
          <v-card-text class="pt-4">
            <div class="subtitle-1 font-weight-bold mb-4">
              รหัสอ้างอิง:
              <span class="primary--text">{{ selectedManageRef }}</span>
            </div>

            <v-timeline dense align-top v-if="manageLogs.length > 0">
              <v-timeline-item
                v-for="log in manageLogs"
                :key="log.log_id"
                :color="getLogColor(log.log_action)"
                :icon="getLogIcon(log.log_action)"
                fill-dot
                small
              >
                <v-card class="elevation-1">
                  <v-card-title class="subtitle-2 py-2">
                    {{ log.log_action.toUpperCase() }}
                    <v-spacer></v-spacer>
                    <span class="caption grey--text">{{
                      log.log_datetime
                    }}</span>
                  </v-card-title>
                  <v-card-text class="pb-2">
                    <p class="mb-1 text-body-2">{{ log.log_detail }}</p>
                    <div class="caption grey--text">
                      <v-icon x-small>mdi-account-key</v-icon> บัตรประชาชน:
                      {{ log.log_id_card }} |
                      <v-icon x-small>mdi-step-forward</v-icon> ขั้นตอนที่:
                      {{ log.log_step }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
            <v-alert v-else type="info" text class="mt-3"
              >ไม่มีข้อมูลประวัติการทำรายการในระบบ</v-alert
            >
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-layout row justify-center>
        <v-dialog v-model="comment_stb_Drdialog" persistent max-width="750px">
          <v-card class="rounded-xl">
            <v-card-title class="amber darken-3 white--text text-h6 py-4">
              <v-icon dark left>mdi-comment-account-outline</v-icon>
              บันทึกความเห็นผู้อำนวยการสถาบันการอาชีวศึกษา
              <v-spacer></v-spacer>
              <v-btn icon dark @click="comment_stb_Drdialog = false"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-card-title>
            <v-card-text class="pt-6">
              <v-form ref="updatecomment_stbform" lazy-validation>
                <v-card
                  outlined
                  class="mb-6 rounded-lg pa-4"
                  style="border-left: 5px solid #FFC107;"
                >
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <div class="caption grey--text">
                        รหัสอ้างอิง / รหัสบัตรประชาชน
                      </div>
                      <div class="subtitle-1 font-weight-bold">
                        {{ transference_manages_id_ref.manage_id_ref }} <br />
                        <span class="primary--text">{{
                          transference_manages_id_ref.id_card
                        }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="caption grey--text">ชื่อ-นามสกุล</div>
                      <div class="subtitle-1 font-weight-bold">
                        {{ transference_manages_id_ref.title_s
                        }}{{ transference_manages_id_ref.frist_name }}
                        {{ transference_manages_id_ref.last_name }}
                      </div>
                    </v-col>
                    <v-col cols="12"
                      ><v-divider class="my-2"></v-divider
                    ></v-col>
                    <v-col cols="12" sm="6">
                      <div class="caption grey--text">สถานศึกษาปัจจุบัน</div>
                      <div class="subtitle-2">
                        {{ transference_manages_id_ref.college_name }} <br />
                        <span class="grey--text"
                          >เลขที่ตำแหน่ง:
                          {{ transference_manages_id_ref.id_position }}</span
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="caption grey--text">ข้อมูลการย้าย</div>
                      <div class="subtitle-2">
                        ย้ายครั้งที่:
                        {{ transference_manages_id_ref.manage_time_s }} /
                        {{ transference_manages_id_ref.manage_year_s }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card>

                <div class="text-subtitle-1 font-weight-bold mb-3">
                  <v-icon color="primary" left
                    >mdi-file-document-check-outline</v-icon
                  >
                  สถานะการยื่นเสนอเอกสารประกอบการพิจารณา
                </div>
                <v-card outlined class="mb-6 pa-3 rounded-lg bg-lighten-5">
                  <v-radio-group
                    v-model="transference_manages_id_ref.manage_status_document"
                    row
                    class="mt-0"
                    hide-details
                    required
                    :rules="[v => !!v || 'กรุณาเลือกสถานะเอกสาร']"
                  >
                    <v-radio value="complete" color="success">
                      <template v-slot:label
                        ><strong class="success--text"
                          ><v-icon small color="success" left
                            >mdi-check-circle</v-icon
                          >
                          ถูกต้องสมบูรณ์</strong
                        ></template
                      >
                    </v-radio>
                    <v-radio value="incomplete" color="warning">
                      <template v-slot:label
                        ><strong class="warning--text"
                          ><v-icon small color="warning" left
                            >mdi-alert-circle</v-icon
                          >
                          ไม่ถูกต้อง/ไม่สมบูรณ์</strong
                        ></template
                      >
                    </v-radio>
                    <v-radio value="do_not" color="error">
                      <template v-slot:label
                        ><strong class="error--text"
                          ><v-icon small color="error" left>mdi-cancel</v-icon>
                          ไม่จัดส่งเอกสาร</strong
                        ></template
                      >
                    </v-radio>
                  </v-radio-group>
                </v-card>

                <div class="text-subtitle-1 font-weight-bold mb-3">
                  <v-icon color="primary" left>mdi-comment-edit-outline</v-icon>
                  ความคิดเห็นผู้บังคับบัญชา
                </div>
                <v-textarea
                  outlined
                  auto-grow
                  rows="3"
                  label="ระบุความเห็นของผู้อำนวยการสถาบันฯ"
                  v-model="
                    transference_manages_id_ref.manage_comment_supervisor
                  "
                  hide-details="auto"
                  class="rounded-lg"
                  color="amber darken-3"
                ></v-textarea>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-4 grey lighten-4">
              <v-spacer></v-spacer>
              <v-btn
                text
                color="blue-grey darken-1"
                @click.stop="comment_stb_Drdialog = false"
                class="px-4 font-weight-bold"
                >ยกเลิก</v-btn
              >
              <v-btn
                color="success"
                @click.stop="updatecomment_stbSubmit()"
                class="px-6 rounded-pill"
                elevation="2"
              >
                <v-icon left>mdi-content-save-check</v-icon> บันทึกข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="commentDrdialog" persistent max-width="750px">
          <v-card class="rounded-xl">
            <v-card-title class="info darken-1 white--text text-h6 py-4">
              <v-icon dark left>mdi-account-tie</v-icon>
              บันทึกความเห็นผู้อำนวยการวิทยาลัย
              <v-spacer></v-spacer>
              <v-btn icon dark @click="commentDrdialog = false"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-card-title>
            <v-card-text class="pt-6">
              <v-form ref="updatecommentform" lazy-validation>
                <v-card
                  outlined
                  class="mb-6 rounded-lg pa-4"
                  style="border-left: 5px solid #29B6F6;"
                >
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <div class="caption grey--text">
                        รหัสอ้างอิง / รหัสบัตรประชาชน
                      </div>
                      <div class="subtitle-1 font-weight-bold">
                        {{ transference_manages_id_ref.manage_id_ref }} <br />
                        <span class="primary--text">{{
                          transference_manages_id_ref.id_card
                        }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="caption grey--text">ชื่อ-นามสกุล</div>
                      <div class="subtitle-1 font-weight-bold">
                        {{ transference_manages_id_ref.title_s
                        }}{{ transference_manages_id_ref.frist_name }}
                        {{ transference_manages_id_ref.last_name }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card>

                <div class="text-subtitle-1 font-weight-bold mb-3">
                  <v-icon color="primary" left
                    >mdi-clipboard-check-outline</v-icon
                  >
                  ความคิดเห็น
                </div>
                <v-card outlined class="mb-6 pa-3 rounded-lg bg-lighten-5">
                  <v-radio-group
                    v-model="transference_manages_id_ref.comment_dr_c"
                    row
                    hide-details
                    required
                    :rules="[v => !!v || 'กรุณาเลือกความเห็น']"
                  >
                    <v-radio value="approp" color="primary"
                      ><template v-slot:label
                        ><strong class="primary--text"
                          >เห็นควรให้ย้าย</strong
                        ></template
                      ></v-radio
                    >
                    <v-radio value="inapprop" color="warning"
                      ><template v-slot:label
                        ><strong class="warning--text"
                          >ไม่เห็นควรให้ย้าย</strong
                        ></template
                      ></v-radio
                    >
                    <v-radio value="suspend" color="error"
                      ><template v-slot:label
                        ><strong class="error--text"
                          >ระงับย้าย</strong
                        ></template
                      ></v-radio
                    >
                  </v-radio-group>
                </v-card>

                <div class="text-subtitle-1 font-weight-bold mb-3">
                  <v-icon color="primary" left
                    >mdi-file-document-check-outline</v-icon
                  >
                  สถานะเอกสาร
                </div>
                <v-card outlined class="mb-6 pa-3 rounded-lg bg-lighten-5">
                  <v-radio-group
                    v-model="transference_manages_id_ref.manage_status_document"
                    row
                    hide-details
                    required
                    :rules="[v => !!v || 'กรุณาเลือกสถานะเอกสาร']"
                  >
                    <v-radio value="complete" color="success"
                      ><template v-slot:label
                        ><strong class="success--text"
                          >สมบูรณ์</strong
                        ></template
                      ></v-radio
                    >
                    <v-radio value="incomplete" color="warning"
                      ><template v-slot:label
                        ><strong class="warning--text"
                          >ไม่สมบูรณ์</strong
                        ></template
                      ></v-radio
                    >
                    <v-radio value="do_not" color="error"
                      ><template v-slot:label
                        ><strong class="error--text"
                          >ไม่จัดส่ง</strong
                        ></template
                      ></v-radio
                    >
                  </v-radio-group>
                </v-card>

                <v-text-field
                  outlined
                  label="ความเห็นเพิ่มเติมของผู้บังคับบัญชา :"
                  v-model="transference_manages_id_ref.detail_comment"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-4 grey lighten-4">
              <v-spacer></v-spacer>
              <v-btn
                text
                color="blue-grey darken-1"
                @click.stop="commentDrdialog = false"
                class="px-4 font-weight-bold"
                >ยกเลิก</v-btn
              >
              <v-btn
                color="success"
                @click.stop="updatecommentSubmit()"
                class="px-6 rounded-pill"
                elevation="2"
              >
                <v-icon left>mdi-content-save-check</v-icon> บันทึกข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="positiondialog" persistent max-width="80%">
          <v-card class="mx-auto pa-4 rounded-xl">
            <v-card-title
              class="amber darken-3 white--text text-h6 rounded-lg mb-4"
            >
              <v-icon left dark>mdi-map-marker-plus</v-icon> เลือกสถานศึกษา
            </v-card-title>
            <v-card-text>
              <v-form ref="updatepositionform" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-card outlined class="pa-4 mb-4 bg-lighten-5">
                        <div class="subtitle-1 font-weight-bold">
                          รหัสอ้างอิง :
                          <span class="primary--text">{{
                            transference_manages_id_ref.manage_id_ref
                          }}</span>
                          | บัตรประชาชน :
                          {{ transference_manages_id_ref.id_card }}
                        </div>
                        <div class="subtitle-1 mt-2">
                          ชื่อ-นามสกุล : {{ transference_manages_id_ref.title_s
                          }}{{ transference_manages_id_ref.frist_name }}
                          {{ transference_manages_id_ref.last_name }}
                        </div>
                        <div class="subtitle-1 mt-2">
                          สถานศึกษาปัจจุบัน :
                          {{ transference_manages_id_ref.college_code }}
                          {{ transference_manages_id_ref.college_name }} |
                          เลขที่ตำแหน่ง :
                          {{ transference_manages_id_ref.id_position }}
                        </div>
                        <div class="subtitle-2 grey--text mt-2">
                          อายุงาน ณ สถานศึกษาปัจจุบัน โดยใช้วันที่ :
                          {{
                            periods.period_cal_end
                              | moment("add", "543 years")
                              | moment("D MMMM YYYY")
                          }}
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-data-table
                        color="success"
                        :loading="loading"
                        :headers="header_trans"
                        :items="transference_manage_locations"
                        class="elevation-1 mb-4"
                        hide-default-footer
                      ></v-data-table>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-card elevation="1" class="pa-4 border-left-info">
                        <h3 class="primary--text mb-2">
                          <v-icon color="primary">mdi-message-text</v-icon>
                          เหตุผลในการย้าย :
                        </h3>
                        <div class="subtitle-1">
                          {{ transference_manages_id_ref.manage_reason_detail }}
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="12" class="mt-4">
                      <v-card elevation="2" class="pa-4">
                        <h3 class="mb-4">กำหนดสถานศึกษาและตำแหน่งปลายทาง</h3>
                        <v-autocomplete
                          prepend-icon="mdi-domain"
                          :items="colleges"
                          item-text="college_name"
                          item-value="college_code"
                          v-model="updatepositions.college_code"
                          label="เลือกวิทยาลัยปลายทาง"
                          @change="man_powerQuery()"
                          required
                          :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
                          outlined
                        ></v-autocomplete>

                        <v-autocomplete
                          prepend-icon="mdi-badge-account-outline"
                          :items="man_powers"
                          item-text="college_position_case"
                          item-value="id_position"
                          label="เลขที่ตำแหน่ง"
                          v-model="updatepositions.id_position"
                          outlined
                          required
                          :rules="[v => !!v || 'กรุณาเลือกตำแหน่ง']"
                        ></v-autocomplete>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn
                large
                text
                color="grey darken-2"
                @click.stop="positiondialog = false"
                rounded
              >
                <v-icon left>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="updatepositionSubmit()"
                rounded
              >
                <v-icon left>mdi-content-save</v-icon>บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="canceldialog" persistent max-width="800px">
          <v-card class="mx-auto pa-4 rounded-xl">
            <v-card-title class="error white--text text-h6 rounded-lg mb-4">
              <v-icon left dark>mdi-alert-circle</v-icon> ยกเลิกรายการคัดเลือก
            </v-card-title>
            <v-card-text>
              <v-form ref="cancelform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md6>
                      <div class="subtitle-1 font-weight-bold mb-2">
                        ข้อมูลผู้ขอย้าย
                      </div>
                      <p>
                        รหัสอ้างอิง :
                        <span class="primary--text">{{
                          transference_manages_id_ref.id_ref ||
                            transference_manages_id_ref.manage_id_ref
                        }}</span>
                      </p>
                      <p>
                        รหัสบัตรประชาชน :
                        {{ transference_manages_id_ref.id_card }}
                      </p>
                      <p>
                        ชื่อ-นามสกุล : {{ transference_manages_id_ref.title_s
                        }}{{ transference_manages_id_ref.frist_name }}
                        {{ transference_manages_id_ref.last_name }}
                      </p>
                      <p>
                        สถานศึกษาปัจจุบัน :
                        {{ transference_manages_id_ref.college_name }}
                      </p>
                      <p>
                        เลขที่ตำแหน่ง :
                        {{ transference_manages_id_ref.id_position }}
                      </p>
                    </v-flex>
                    <v-flex md6>
                      <div class="subtitle-1 font-weight-bold mb-2 error--text">
                        ข้อมูลปลายทางที่ต้องการยกเลิก
                      </div>
                      <p>
                        รหัสวิทยาลัยปลายทาง :
                        {{ man_powerss.college_code || "สับเปลี่ยนตำแหน่ง" }}
                      </p>
                      <p>
                        วิทยาลัย :
                        {{ man_powerss.college_name || "สับเปลี่ยนตำแหน่ง" }}
                      </p>
                      <p>
                        เลขที่ตำแหน่ง :
                        {{ man_powerss.id_position || "สับเปลี่ยนตำแหน่ง" }}
                      </p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn
                large
                text
                color="grey darken-2"
                @click.stop="canceldialog = false"
                rounded
              >
                <v-icon left>mdi-close</v-icon>ปิด
              </v-btn>
              <v-btn large color="warning" @click.stop="cancelSubmit()" rounded>
                <v-icon left>mdi-check-bold</v-icon>ยืนยันการยกเลิก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>


      <!-- Dialog Preview File -->
       <v-dialog v-model="previewDialog" max-width="90%">
        <v-card class="rounded-xl">
          <v-card-title class="blue-grey darken-4 white--text text-h6 py-4">
            <v-icon dark left>mdi-file-pdf-box</v-icon>
            ดูตัวอย่างไฟล์แนบ
            <v-spacer></v-spacer>
            <v-btn icon dark @click="previewDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-title>
          <v-card-text class="pt-4">
            <iframe
              v-if="previewUrl"
              :src="'/uploads/transference_manage/' + previewUrl"
              width="100%"
              height="600px"
              frameborder="0"
            ></iframe>
            <div v-else class="text-center py-10">
              <v-icon x-large color="grey">mdi-file-pdf-box</v-icon>
              <p class="subtitle-1 grey--text mt-2">ไม่พบไฟล์แนบ</p>
            </div>
          </v-card-text>
        </v-card>

       </v-dialog>

      <v-container fluid>
        <v-snackbar
          v-model="snackbar.show"
          top
          :timeout="snackbar.timeout"
          :color="snackbar.color"
        >
          <v-icon large left dark>{{ snackbar.icon }}</v-icon>
          <span class="text-subtitle-1 white--text">{{ snackbar.text }}</span>
          <template v-slot:action="{ attrs }">
            <v-btn text white v-bind="attrs" @click="snackbar.show = false"
              >ปิด</v-btn
            >
          </template>
        </v-snackbar>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import transferenceManagebar from "../../components/admin/transferenceManagebar.vue";
import * as XLSX from "xlsx";

export default {
  components: { transferenceManagebar },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      position: "",
      search: "",

      // Dialogs
      logDialog: false,
      comment_stb_Drdialog: false,
      commentDrdialog: false,
      positiondialog: false,
      canceldialog: false,
      clear_dataDialog: false,

      // Data & References
      manageLogs: [],
      selectedManageRef: "",
      transference_manages: [],
      transference_manage_locations: [],
      transference_manages_id_ref: {},
      transference_manages_id_tfp: {},
      colleges: [],
      man_powers: [],
      man_powerss: {},
      conditons_transfer_successs: {},
      updatepositions: {},
      updatepositions_condition: {},
      addreturn_man_power: {},
      man_power_cancel: {},
      updatecomment: {},

      // Selectors & Config
      times_select: "1",
      years_select: "2565",
      periods: { period_times: "1", period_year: "2569", period_cal_end: "" },

      // Stats Counters
      countAll: 0,
      countSaves: 0,
      countTem: 0,
      countNormal: 0,
      countquality: 0,
      countsp: 0,
      // Stats by position type (จากคิวรีรวมฝั่ง SQL — ไม่ต้อง loop ฝั่ง client อีกต่อไป)
overallStat: { total: 0, saved: 0, pending: 0, case_normal: 0, case_quality: 0, case_special: 0 },
positionStats: [],
positionLabels: {
  director: { label: "ผู้อำนวยการ", color: "primary", icon: "mdi-account-tie" },
  se_director: { label: "รองผู้อำนวยการ", color: "info", icon: "mdi-account-tie-outline" }
},
jor18VacantSummary: { director: 0, se_director: 0 },

      // UI
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },

      // Tables Headers
      header_trans: [
        { text: "ลำดับ", align: "center", value: "manage_location_sequence_n" },
        {
          text: "รหัสอ้างอิง",
          align: "center",
          value: "manage_location_id_ref"
        },
        { text: "วิทยาลัย", align: "left", value: "college_name" }
      ],
      headersMap: [
        {
          text: "ยกเลิกบันทึก",
          align: "center",
          value: "actionCancel",
          sortable: false
        },
        { text: "สถานะ", align: "center", value: "manage_status_save" },
        { text: "กรณี", align: "center", value: "manage_case_move" },
        { text: "Ref", align: "center", value: "manage_id_ref" },
        { text: "ชื่อ", align: "left", value: "frist_name" },
        { text: "นามสกุล", align: "left", value: "last_name" },
        {
          text: "ไฟล์แนบ",
          align: "center",
          value: "attachment",
          sortable: false
        },
        { text: "Log", align: "center", value: "history", sortable: false },
        { text: "เอกสาร", align: "center", value: "print", sortable: false },
        { text: "สถานศึกษาปัจจุบัน", align: "left", value: "college_name" },
        {
          text: "ความเห็นผู้บังคับฯ",
          align: "center",
          value: "manage_comment_supervisor"
        },
        {
          text: "สถานะเอกสาร",
          align: "center",
          value: "manage_status_document"
        },
        { text: "แห่งใหม่", align: "center", value: "succ_college" },
        {
          text: "ตำแหน่งว่างอันดับ 1 (jor18)",
          align: "center",
          value: "jor18_vacant_top_choice"
        },
        {
          text: "คัดเลือก",
          align: "center",
          value: "actions",
          sortable: false
        },
        { text: "ลบ", align: "center", value: "action", sortable: false }
      ],
      headers: [],
      selectedHeaders: [],
      previewDialog: false,
      previewUrl: ""
    };
  },
  async created() {
    this.headers = Object.values(this.headersMap);
    // ซ่อนคอลัมน์ลบ/ยกเลิก ไว้เป็น Default เพื่อความสะอาดตา
    this.selectedHeaders = this.headers.filter(
      h =>
        !["actionCancel", "action", "manage_status_document"].includes(h.value)
    );
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async statQuery() {
  let res = await this.$http.post("transference_manage_stat.php", {
    ApiKey: this.ApiKey,
    manage_time_s: this.periods.period_times,
    manage_year_s: this.periods.period_year
  });
  this.overallStat = res.data.overall;
  this.positionStats = res.data.by_position;
},

    /** จำนวนตำแหน่งว่างคงเหลือทั้งระบบ ตามกรอบอัตรากำลัง jor18 (id_card ว่าง) แยกตามตำแหน่ง */
    async jor18StatQuery() {
      let [dr, sedr] = await Promise.all([
        this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          positions: "ผู้อำนวยการวิทยาลัย",
          idpostion_null: "ok"
        }),
        this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          positions: "รองผู้อำนวยการวิทยาลัย",
          idpostion_null: "ok"
        })
      ]);
      this.jor18VacantSummary = {
        director: (dr.data || []).length,
        se_director: (sedr.data || []).length
      };
    },
    printPreview(item) {
      if (item) {
        this.previewUrl = item;
        this.previewDialog = true;
      } else {
        this.snackbar = {
          show: true,
          color: "info",
          icon: "mdi-information",
          text: "ไม่พบไฟล์แนบสำหรับรายการนี้"
        };
      }
    },
    exportToExcel() {
      try {
        const data = this.transference_manages.map(item => {
          const row = {};
          this.showHeaders.forEach(h => {
            if (h.sortable === false) return;
            const val = item[h.value];
            row[h.text] = val !== null && val !== undefined && val !== "" ? val : "-";
          });
          return row;
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Transference_Manage");

        const filename = `รายการย้ายสายบริหาร_${this.periods.period_times}_${this.periods.period_year}.xlsx`;
        XLSX.writeFile(wb, filename);

        this.snackbar = {
          show: true,
          color: "success",
          icon: "mdi-check-circle",
          text: "ส่งออกไฟล์ Excel เรียบร้อย"
        };
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.snackbar = {
          show: true,
          color: "error",
          icon: "mdi-alert-circle",
          text: "เกิดข้อผิดพลาดในการส่งออก"
        };
      }
    },
    async initData() {
      let result_col = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result_col.data;
      await this.periodQuery();
      await this.transference_manageQueryAll();
       await this.statQuery();
       await this.jor18StatQuery();
    },

    async periodQuery() {
      let res = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_type: "manage"
      });
      this.periods = res.data;
    },

    async transference_manageQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_manage.php", {
          ApiKey: this.ApiKey,
          transferce_manage_main: "Check",
          manage_time_s: this.periods.period_times,
          manage_year_s: this.periods.period_year
        });
        this.transference_manages = res.data || [];
        this.calculateStats();
      } finally {
        this.loading = false;
      }
    },

    calculateStats() {
      let s = 0,
        t = 0,
        n = 0,
        q = 0,
        sp = 0;
      this.transference_manages.forEach(v => {
        if (
          v.manage_status_save === "Save" ||
          v.manage_status_save === "Confirm"
        )
          s++;
        else t++;
        if (v.manage_case_move === "normal") n++;
        else if (v.manage_case_move === "quality") q++;
        else if (v.manage_case_move === "special") sp++;
      });
      this.countAll = this.transference_manages.length;
      this.countSaves = s;
      this.countTem = t;
      this.countNormal = n;
      this.countquality = q;
      this.countsp = sp;
    },

    async positionSearch() {
      this.loading = true;
      let res = await this.$http
        .post("transference_manage.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.periods.period_times,
          manage_year_s: this.periods.period_year,
          position_name: this.position
        })
        .finally(() => (this.loading = false));
      this.transference_manages = res.data || [];
    },

    async searchTimeYear() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.periods.period_times,
          manage_year_s: this.years_select.period_year
        })
        .finally(() => (this.loading = false));
      this.transference_manages = result.data || [];
    },

    async showSuccessPosition() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.times_select,
          manage_year_s: this.years_select,
          success_s: "ok"
        })
        .finally(() => (this.loading = false));
      this.transference_manages = result.data || [];
    },

    // ----------------- LOGS & HISTORY -----------------
    async openLogHistory(ref) {
      this.selectedManageRef = ref;
      this.loading = true;
      try {
        let res = await this.$http.post("transference_manage_log.select.php", {
          ApiKey: this.ApiKey,
          log_manage_id_ref: ref
        });
        this.manageLogs = res.data || [];
        this.logDialog = true;
      } finally {
        this.loading = false;
      }
    },
    getLogColor(action) {
      const colors = {
        insert: "info",
        update: "warning",
        upload_file: "primary",
        save_final: "success",
        submit_final: "success darken-2",
        cancel: "error"
      };
      return colors[action] || "grey";
    },
    getLogIcon(action) {
      const icons = {
        insert: "mdi-plus",
        update: "mdi-pencil",
        upload_file: "mdi-file-upload",
        save_final: "mdi-content-save-check",
        submit_final: "mdi-check-decagram",
        cancel: "mdi-cancel"
      };
      return icons[action] || "mdi-information-variant";
    },

    // ----------------- OPEN DIALOGS -----------------
    async select_idPosition(manage_id_ref) {
      let data = {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      };
      let result_con = await this.$http.post("transference_manage.php", data);
      let data_location = {
        ApiKey: this.ApiKey,
        manage_location_id_ref: manage_id_ref
      };  
      let result = await this.$http.post("transference_manage_location.php", data_location);  
      this.transference_manage_locations = result.data;
      this.transference_manages_id_ref = result_con.data;
      this.positiondialog = true;
    },

    async comment_idPosition(manage_id_ref) {
      let result_con = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.transference_manages_id_ref = result_con.data;
      this.commentDrdialog = true;
    },

    async manage_comment_supervisorPosition(manage_id_ref) {
      let result_con = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.transference_manages_id_ref = result_con.data;
      this.comment_stb_Drdialog = true;
    },

    async deletePosition(manage_id_ref) {
      let result_con = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.transference_manages_id_ref = result_con.data;

      let result_man = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        id_card: this.transference_manages_id_ref.id_card
      });
      this.man_powerss = result_man.data;

      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.conditons_transfer_successs = result_cts.data;
      this.canceldialog = true;
    },

    async man_powerQuery() {
      let man_power_result = await this.$http.post("man_power_process.php", {
        ApiKey: this.ApiKey,
        college_code: this.updatepositions.college_code
      });
      this.man_powers = man_power_result.data;
    },

    // ----------------- ACTIONS & SUBMITS -----------------
    async updatecommentSubmit() {
      if (this.$refs.updatecommentform.validate()) {
        this.updatecomment.ApiKey = this.ApiKey;
        this.updatecomment.id_tfp = this.transference_manages_id_ref.id_tfp;
        this.updatecomment.comment_dr_c = this.transference_manages_id_ref.comment_dr_c;
        this.updatecomment.id_branch = this.transference_manages_id_ref.id_branch_tan;
        this.updatecomment.detail_comment = this.transference_manages_id_ref.detail_comment;
        this.updatecomment.manage_status_document = this.transference_manages_id_ref.manage_status_document;

        let result = await this.$http.post(
          "transference_manage.update.php",
          this.updatecomment
        );
        if (result.data.status == true) {
          swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manageQueryAll();
        } else {
          swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.commentDrdialog = false;
      }
    },

    async updatecomment_stbSubmit() {
      if (this.$refs.updatecomment_stbform.validate()) {
        this.updatecomment.ApiKey = this.ApiKey;
        this.updatecomment.manage_id_ref = this.transference_manages_id_ref.manage_id_ref;
        this.updatecomment.manage_comment_supervisor = this.transference_manages_id_ref.manage_comment_supervisor;
        this.updatecomment.manage_status_document = this.transference_manages_id_ref.manage_status_document;

        let result = await this.$http.post(
          "transference_manage.update.php",
          this.updatecomment
        );
        if (result.data.status == true) {
          swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manageQueryAll();
        } else {
          swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.comment_stb_Drdialog = false;
      }
    },

    async updatepositionSubmit() {
      if (this.$refs.updatepositionform.validate()) {
        this.updatepositions.ApiKey = this.ApiKey;
        this.updatepositions.time_s = this.transference_manages_id_ref.manage_time_s;
        this.updatepositions.year_s = this.transference_manages_id_ref.manage_year_s;
        this.updatepositions.college_code_old = this.transference_manages_id_ref.college_code;
        this.updatepositions.id_postion_old = this.transference_manages_id_ref.id_position;
        this.updatepositions.id_card = this.transference_manages_id_ref.id_card;
        this.updatepositions.id_ref = this.transference_manages_id_ref.manage_id_ref;
        this.updatepositions.name_position = this.position;
        this.updatepositions.status_select = "demand";

        this.updatepositions_condition.ApiKey = this.ApiKey;
        this.updatepositions_condition.id_position = this.updatepositions.id_position;
        this.updatepositions_condition.status_booking = this.transference_manages_id_ref.id_card;

        this.addreturn_man_power.ApiKey = this.ApiKey;
        this.addreturn_man_power.college_code = this.transference_manages_id_ref.college_code;
        this.addreturn_man_power.id_position = this.transference_manages_id_ref.id_position;
        this.addreturn_man_power.position = this.position;
        this.addreturn_man_power.case_vacancy =
          "ย้ายรอบ-" +
          this.transference_manages_id_ref.manage_time_s +
          "/" +
          this.transference_manages_id_ref.manage_year_s;

        let result_man_return = await this.$http.post(
          "man_power.insert.php",
          this.addreturn_man_power
        );

        if (result_man_return.data.status == true) {
          let result_man = await this.$http.post(
            "man_power.update_process.php",
            this.updatepositions_condition
          );
          let result = await this.$http.post(
            "conditons_transfer_success.insert.php",
            this.updatepositions
          );

          if (result_man.data.status == true && result.data.status == true) {
            this.snackbar = {
              show: true,
              icon: "mdi-check-circle",
              color: "success",
              text: "บันทึกข้อมูลเรียบร้อย"
            };
            this.transference_manageQueryAll();
          }
        } else {
          swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.positiondialog = false;
      }
    },

    async cancelSubmit() {
      if (this.$refs.cancelform.validate()) {
        this.man_powerss.ApiKey = this.ApiKey;
        this.man_powerss.status_booking = "";

        this.conditons_transfer_successs.ApiKey = this.ApiKey;

        this.man_power_cancel.ApiKey = this.ApiKey;
        this.man_power_cancel.id_position = this.conditons_transfer_successs.id_postion_old;

        let result_man = await this.$http.post(
          "man_power.update_process.php",
          this.man_powerss
        );
        let result_man_delete = await this.$http.post(
          "man_power.delete.php",
          this.man_power_cancel
        );
        let result_cts = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successs
        );

        if (
          result_man.data.status == true &&
          result_cts.data.status == true &&
          result_man_delete.data.status == true
        ) {
          this.snackbar = {
            show: true,
            icon: "mdi-check-circle",
            color: "success",
            text: "ยกเลิกข้อมูลเรียบร้อย"
          };
          this.transference_manageQueryAll();
        } else {
          this.snackbar = {
            show: true,
            icon: "mdi-close-circle",
            color: "error",
            text: "ยกเลิกข้อมูลผิดพลาด"
          };
        }
        this.canceldialog = false;
      }
    },

    // ----------------- DELETE & CANCEL -----------------
    async CancelSave(manage_id_tfp) {
      let result = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_tfp: manage_id_tfp
      });
      this.transference_manages_id_tfp = result.data;
      let id_tfp =
        this.transference_manages_id_tfp.title_s +
        this.transference_manages_id_tfp.frist_name +
        " " +
        this.transference_manages_id_tfp.last_name;

      swal.fire({
        title: "ต้องการยกเลิกสถานะการบันทึกรายการนี้ ?",
        text: id_tfp,
        input: "text",
        inputAttributes: { autocapitalize: "off" },
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        showLoaderOnConfirm: true,
        preConfirm: async login => {
          if (login === "0612698358") {
            this.transference_manages_id_tfp.ApiKey = this.ApiKey;
            this.transference_manages_id_tfp.manage_status_save = "1";
            let resultdel = await this.$http.post(
              "transference_manage.update.php",
              this.transference_manages_id_tfp
            );
            if (resultdel.data.status == true) {
              swal.fire({
                icon: "success",
                title: "ดำเนินการเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });
              await this.transference_manageQueryAll();
            } else {
              swal.fire({
                icon: "warning",
                title: "ดำเนินการผิดพลาด",
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        }
      });
    },

    async CancelTransference(manage_id_tfp) {
      let result = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_tfp: manage_id_tfp
      });
      this.transference_manages_id_tfp = result.data;
      let id_tfp =
        this.transference_manages_id_tfp.title_s +
        this.transference_manages_id_tfp.frist_name +
        " " +
        this.transference_manages_id_tfp.last_name;

      swal.fire({
        title: "ต้องการยกเลิกรายการบันทึกนี้ ?",
        text: id_tfp,
        input: "text",
        inputAttributes: { autocapitalize: "off" },
        showCancelButton: true,
        confirmButtonText: "ยืนยันยกเลิกบันทึก",
        showLoaderOnConfirm: true,
        preConfirm: async login => {
          if (login === "0612698358") {
            this.transference_manages_id_tfp.ApiKey = this.ApiKey;
            this.transference_manages_id_tfp.manage_status_save = 17;
            let resultcancel = await this.$http.post(
              "transference_manage.update.php",
              this.transference_manages_id_tfp
            );
            if (resultcancel.data.status == true) {
              swal.fire({
                icon: "success",
                title: "ดำเนินการเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });
              await this.transference_manageQueryAll();
            } else {
              swal.fire({
                icon: "warning",
                title: "ดำเนินการผิดพลาด",
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        }
      });
    },

    async DelTransference(manage_id_tfp) {
      let result = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_tfp: manage_id_tfp
      });
      this.transference_manages_id_tfp = result.data;
      let id_tfp =
        this.transference_manages_id_tfp.title_s +
        this.transference_manages_id_tfp.frist_name +
        " " +
        this.transference_manages_id_tfp.last_name;

      swal.fire({
        title: "ต้องการลบรายการนี้ ?",
        text: id_tfp,
        input: "text",
        inputAttributes: { autocapitalize: "off" },
        showCancelButton: true,
        confirmButtonText: "ยืนยันลบ",
        showLoaderOnConfirm: true,
        preConfirm: async login => {
          if (login === "0612698358") {
            this.transference_manages_id_tfp.ApiKey = this.ApiKey;
            let resultdel = await this.$http.post(
              "transference_manage.delete.php",
              this.transference_manages_id_tfp
            );
            if (resultdel.data.status == true) {
              swal.fire({
                icon: "success",
                title: "ลบข้อมูลเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });
              await this.transference_manageQueryAll();
            } else {
              swal.fire({
                icon: "warning",
                title: "ดำเนินการผิดพลาด",
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        }
      });
    },

    getColor(calories) {
      if (calories > 0) return "green";
      else return "";
    }
  },
  computed: {
    pages() {
      if (
        this.pagination &&
        (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null)
      )
        return 0;
      return Math.ceil(
        (this.pagination?.totalItems || 0) / (this.pagination?.rowsPerPage || 1)
      );
    },
    period_years() {
      return this.periods.period_year;
    },
    color() {
      return "lime darken-4";
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
  }
};
</script>

<style scoped>
.border-left-info {
  border-left: 6px solid #2196f3 !important;
}
.border-left-primary {
  border-left: 6px solid #1565c0 !important;
}
.border-left-warning {
  border-left: 6px solid #ffb300 !important;
}
.rounded-xl {
  border-radius: 16px !important;
}
.bg-lighten-5 {
  background-color: #fafafa !important;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
</style>
